import { NotificationManager } from 'react-notifications';

export const NOTIFY_INFO = 'info';
export const NOTIFY_SUCCESS = 'success';
export const NOTIFY_WARNING = 'warning';
export const NOTIFY_ERROR = 'error';
/**
 * Creates a notification
 */
export const createNotification = (type, text, timeout) => {
  const autoCloseTimeout = timeout || undefined;

  switch (type) {
    case NOTIFY_INFO:
      NotificationManager.info('Info', text || '', autoCloseTimeout);
      break;
    case NOTIFY_SUCCESS:
      NotificationManager.success('', text || '', autoCloseTimeout);
      break;
    case NOTIFY_WARNING:
      NotificationManager.warning('Advertencia', text || '', autoCloseTimeout);
      break;
    case NOTIFY_ERROR:
      NotificationManager.error('Error', text || 'Ha ocurrido un error, por favor intenta de nuevo.', autoCloseTimeout);
      break;
    default:
      break;
  }
};

export const createInfoMessage = (text, timeout) => createNotification(NOTIFY_INFO, text, timeout);
export const createSuccessMessage = (text, timeout) => createNotification(NOTIFY_SUCCESS, text, timeout);
export const createWarningMessage = (text, timeout) => createNotification(NOTIFY_WARNING, text, timeout);
export const createErrorMessage = (text, timeout) => createNotification(NOTIFY_ERROR, text, timeout);
